/** Shared with material-log genre dropdown (SubmissionsTableRow). */
const GENRE_OPTIONS = [
  'Arthouse',
  'Biopic',
  'Slasher',
  'Paranormal',
  'Found Footage',
  'Psychological',
  'Dark Comedy',
  'Slapstick',
  'Heist',
  'Thriller',
  'Musical',
  'Non-Fiction',
  'Educational',
  'Technical',
  'Action',
  'Adventure',
  'Comedy',
  'Drama',
  'Horror',
  'Romance',
  'Science Fiction',
  'Fantasy',
  'Documentary',
  'Film Noir',
  'Western',
  'Historical',
  'Crime'
];

export default GENRE_OPTIONS;
